import { AUTH_ACTIONS, AuthActions, AuthCredentials, AuthLoadUser, AuthState } from './types'
import { Dispatch } from 'redux'
import AuthApi from './authApi'
import { RootState } from '../../types'
import { Logger } from '../../../shared/logger/Logger'

export const AuthInitialState: AuthState = {
  user: undefined
}

const authReducer = (state: AuthState = AuthInitialState, action: AuthActions) => {
  switch (action.type) {
    case AUTH_ACTIONS.LOAD_DATA:
      return {
        ...state,
        user: action.user
      }
    default:
      return state
  }
}

export default authReducer

// ACTIONS
export const loginUser = (data: AuthCredentials) => async (dispatch: Dispatch<AuthLoadUser>) => {
  try {
    const { token, user } = (await AuthApi.login(data)).data
    dispatch({ type: AUTH_ACTIONS.LOAD_DATA, user })
    AuthApi.setUserToken(token)
  } catch (e) {
    Logger.log(e)
    throw new Error(e)
  }
}

export const getUser = () => async (dispatch: Dispatch<AuthLoadUser>) => {
  try {
    const { user } = (await AuthApi.load()).data
    dispatch({ type: AUTH_ACTIONS.LOAD_DATA, user })
  } catch (e) {
    Logger.log(e)
    throw new Error(e)
  }
}

// SELECTORS
export const selectUser = (state: RootState) => state.auth.user
